module.exports = __webpack_public_path__ + "857b4d06fab9a0feed31cb3c04de36d9.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/quarantaene2.jpg
// module id = 496
// module chunks = 0